import PageBanner from "../../../../src/components/PageBanner";
import Offres from "../../../../src/components/Offres";
import * as React from 'react';
export default {
  PageBanner,
  Offres,
  React
};